<template>
  <div class="container">
    <div class="top-box">
      <span>{{$t('solution')}}</span>
    </div>

    <div class="content-container">
      <div class="solution-box">
        <p class="solutionTitle" v-html="$t('solutionTitle')"></p>
        <p :class="isEn ? 'en-desc-p' : ''" v-html="$t('solutionDes')"></p>

        <!-- <div class="solution-flex">
          <div v-for="(item, index) in solutionsArray" 
              :key="index"
              class="solution-item"
              @mouseenter="solutionMouseEnter(index)"
              @mouseleave="solutionMouseLeave(index)"
              :style="{'backgroundImage': 'url(' + item.bgSrc + ')', backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: '100%'}"
            >

            <div class="titleBox" v-show="!solutionDetailVisible[index]" >
              <span>{{item.title}}</span>
            </div>

            <transition>
              <div class="description-box" 
                  v-show="solutionDetailVisible[index]" 
               >
                <img :src="item.iconSrc" />
                <span>{{item.title}}</span>
                <div class="lineDiv">1</div>
                <p>{{item.desc}}</p>
                <el-button class="knowBtn" @click="jumpBusiness">{{$t('knowMore')}}</el-button>
              </div>
            </transition>
          </div>
        </div> -->

        <el-row>
          <el-col v-for="(item, index) in solutionsArray" 
                  :key="index"
                  class="solution-col"
                  :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12"
                  :xl="12">
            <div 
                class="solution-item"
                @mouseenter="solutionMouseEnter(index)"
                @mouseleave="solutionMouseLeave(index)"
                :style="{'backgroundImage': 'url(' + item.bgSrc + ')', backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: '100%'}"
              >

              <div class="titleBox" v-show="!solutionDetailVisible[index]" >
                <span>{{$t(item.title)}}</span>
              </div>

              <transition>
                <div class="description-box" 
                    v-show="solutionDetailVisible[index]" 
                >
                  <img :src="item.iconSrc" />
                  <span>{{$t(item.title)}}</span>
                  <div class="lineDiv">1</div>
                  <div class="desc-box">
                    <p :class="isEn ? 'en-detail-desc' : ''" v-html="$t(item.desc)"></p>
                  </div>
                  <!-- <el-button class="knowBtn" @click="jumpBusiness">{{$t('knowMore')}}</el-button> -->
                </div>
              </transition>
            </div>
          </el-col>
        </el-row>

      </div>

      <div class="advantage-box">
        <p v-html="$t('advantage')"></p>
        <img :src="advantageUrl"/>
      </div>

      <div class="fintech-box">
        <p v-html="$t('fintechTitle')"></p>
        <p :class="isEn ? 'en-desc-p' : ''" v-html="$t('fintechDesc')"></p>

        <div class="modao-box">
          <div class="modao-content">
            <span class="fintech-title">{{$t('modao')}}</span>
            <span class="fintech-desc">{{$t('modaoDesc')}}</span>
            <span class="fintech-detail">{{$t('modaoDetail')}}</span>
            <el-button class="fintech-btn" @click="jumpModao">{{$t('knowMore')}}</el-button>
          </div>
        </div>
        <div class="mohe-box">
          <div class="mohe-content">
            <span class="fintech-title">{{$t('mohe')}}</span>
            <span class="fintech-desc">{{$t('moheDesc')}}</span>
            <span class="fintech-detail">{{$t('moheDetail')}}</span>
            <el-button class="fintech-btn" @click="jumpMohe">{{$t('knowMore')}}</el-button>
          </div>
        </div>
      </div>

      <div class="saas-box">
        <p v-html="$t('saasDesc')"></p>
        <!-- <div class="saas-flex">
          <solution-item
            v-for="(item,index) in saasArray"
            :key="index"
            :item=item
          />
        </div> -->
        <el-row>
          <el-col :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12"
                  :xl="12"
                  class="saas-col"
                  v-for="(item,index) in saasArray"
                  :key="index">
            <solution-item
             
              :item=item />
          </el-col>
        </el-row>

      </div>

      <div class="saas-box things-box">
        <p v-html="$t('thingsDesc')"></p>
        <!-- <div class="saas-flex">
          <solution-item
            v-for="(item,index) in thingsnetArray"
            :key="index"
            :item=item
          />
        </div> -->
        <el-row>
          <el-col :xs="24"
                  :sm="12"
                  :md="12"
                  :lg="12"
                  :xl="12"
                  class="saas-col"
                  v-for="(item,index) in thingsnetArray"
                  :key="index">
            <solution-item
              :item=item />
          </el-col>
        </el-row>

      </div>
    </div>

    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';
import SolutionItem from '@/components/SolutionItem';

export default {

  data(){
    return {
      isEn:  false,
      advantageUrl: require('../assets/ourAdvantage.png'),
      solutionsArray: [
        {
          bgSrc: require('../assets/eshopPlatform.png'),
          title: 'eshopPlatform',
          iconSrc: require('../assets/momEshop.png'),
          desc: 'eshopPlatformDesc',
        },
        {
          bgSrc: require('../assets/o2oPlatform.png'),
          title: 'o2oPlatform',
          iconSrc: require('../assets/o2oIcon.png'),
          desc: 'o2oPlatformDesc',
        },
        {
          bgSrc: require('../assets/consumePlatform.png'),
          title: 'consumePlatform',
          iconSrc: require('../assets/comsumeEshop.png'),
          desc: 'consumePlatformDesc',
        },
        {
          bgSrc: require('../assets/momPlatform.png'),
          title: 'momPlatform',
          iconSrc: require('../assets/momEshop.png'),
          desc: 'momPlatformDesc',
        },
      ],
      solutionDetailVisible: [false, false, false, false],

      saasArray:[
        {
          src: require('../assets/crm_service.png'),
          title: 'saasDetail1',
        },
        {
          src: require('../assets/oa_service.png'),
          title: 'saasDetail2',
        },
      ],
      thingsnetArray: [
        {
          src: require('../assets/thinkhome.png'),
          title: 'thinkHome',
          detail: 'thinkHomeDetail'
        },
        {
          src: require('../assets/thinkoffice.png'),
          title: 'thinkoffice',
          detail: 'thinkofficeDetail'
        },
      ]
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.isEn = false;
      this.advantageUrl = require('../assets/ourAdvantage.png');
    }else{
      this.isEn = true;
      this.advantageUrl = require('../assets/enourAdvantage.png');
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.isEn = false;
        this.advantageUrl = require('../assets/ourAdvantage.png');
      }else{
        this.isEn = true;
        this.advantageUrl = require('../assets/enourAdvantage.png');
      }
    }
  },

  methods: {

    jumpModao(){
      this.$router.push('/modao');
    },

    jumpMohe(){
      this.$router.push('/mohe');
    },

    solutionMouseEnter(index){
      this.solutionDetailVisible.splice(index, 1, true)
    },

    solutionMouseLeave(index){
      this.solutionDetailVisible.splice(index, 1, false)
    }
  },

  components: {
    'fix-footer': Footer,
    'solution-item': SolutionItem,
  }
  
}
</script>

<style lang="less" scoped>

.container{
  background-color: #fff;
}

.top-box{
  background: url('../assets/solution_bg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 340px;/*px*/

  span{
    color: #fff;
    font-size: 50px; /*px*/
    display: block;
    line-height: 320px;/*px*/
    text-align: left;
    margin-left: 140px;
  }
}

p{
  font-size:30px;
  font-family:PingFangSC-Semibold,PingFang SC;
  color:rgba(0,0,0,1);
  line-height: 1.5;
  // margin: 0;
  margin-bottom: 35px;
}
.en-desc-p{
  font-size: 26px;
  display: inline-block;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.content-container{
  padding: 40px 200px; 
}

.solution-box{


  p{
    margin: 0;
  }

  .solution-col{

    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 35px;

    .solution-item{

      width: 500px;
      height: 320px;
      margin-bottom: 60px;
      position: relative;
      border-radius:15px;

      .titleBox{
        background-color: #565656;
        opacity: 0.7;
        position: absolute;
        height: 65px; 
        bottom: 0;
        width: 100%;
        border-bottom-left-radius:15px;
        border-bottom-right-radius: 15px;
        color: #fff;
        line-height: 65px;
        font-size: 22px; 
        text-align: left;
        span{
          margin-left: 30px;
          display: block;
        }
      }

      .description-box{
        position: absolute;
        border-radius:15px;
        width: 100%;
        height: 100%;
        // background-color: rgba(86,86,86,0.7);
        background-color: rgba(0,0,0,0.62);
        top: 0;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 30px;
        box-sizing: border-box;

        img{
          object-fit: contain;
          width: 60px;
          height: 60px;
        }
        span{
          font-size: 20px; 
          line-height: 1;
          color: #fff;
          margin-top: 30px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
        }

        .lineDiv{
          width: 125px;
          height: 4px; 
          background-color: #40ACFF;
          margin: 18px auto;
          color: transparent;
          border-radius: 2px;
        }
        
        .desc-box{
          flex: 1;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          p{
            color: #fff;
            font-size: 20px;
            // margin-top: 30px;
            line-height: 1.3;
            margin: 0;
          }
          .en-detail-desc{
            display: inline-block;
            text-align: left;
            font-size: 18px;
            line-height: 1.3;
          }
        }
        .knowBtn{
          width: 150px;
          height: 40px; 
          line-height:20px;
          background: transparent;
          border-color: #40ACFF;
          color: #40ACFF;
          margin: 30px auto 0;
          font-size: 20px; 
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
        }
      }

    }
  }
}

.advantage-box{
  p{
    margin-bottom: 0;
  }
  img{
    object-fit: contain;
    width: 1210px; 
    height: 635px;
  }
}

.fintech-box{

  p{
    margin: 0;
  }

  .modao-box{
    width: 1200px;
    height: 350px; 
    background: url('../assets/modao_solution.png') no-repeat center center;
    background-size: 100% 100%;
    margin: 20px auto;
    display: flex;
    align-items: center;

    .modao-content{
      display: flex;
      flex-direction: column;
      width: 40%;
      height: 80%;
      justify-content: space-around;
      text-align: left;
      margin-left: 7%;
    }
  }

  .mohe-box{
    width: 1200px;
    height: 350px;
    background: url('../assets/mohe_solution.png') no-repeat center center;
    background-size: 100% 100%;
    margin: auto;
    display: flex;
    align-items: center;

    .mohe-content{
      display: flex;
      flex-direction: column;
      width: 40%;
      height: 80%;
      justify-content: space-around;
      text-align: left;
      margin-left: 57%;

    }
  }

  .fintech-title{
    color: #000;
    font-size: 30px; 
    font-family:PingFangSC-Medium,PingFang SC;
  }
  .fintech-desc{
    color: #B3B3B3;
    font-size: 22px;
    line-height: 48px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .fintech-detail{
    color: #000;
    font-size: 22px; 
    line-height:35px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .fintech-btn{
    width: 150px;
    height: 45px; 
    background: transparent;
    border-color: #3B86FE;
    color: #3B86FE;
    display: block;
    font-size:20px; 
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
  }
}

.saas-box{
  padding: 0 90px;

  .saas-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
}

.things-box{
  p{
    margin-top:0;
  }
}

.saas-col{
    display: flex;
    flex-direction: row;
    justify-content: center;
}

@media only screen and (max-width: 992px) {
  .content-container{
    padding: 50px;/*no*/
    p{
      font-size:20px; /*no*/
      line-height: 25px; /*no*/
    }

  }

  .solution-box .solution-col .solution-item{
    width: 300px; /*no*/
    height: 200px; /*no*/
    border-radius: 10px; /*no*/
    .titleBox{
      font-size: 15px; /*no*/
      height: 32px; /*no*/
      border-bottom-left-radius:10px; /*no*/
      border-bottom-right-radius: 10px;/*no*/
      line-height: 32px;/*no*/
    }

    .description-box{
        border-radius:15px;/*no*/
        height: 200px; /*no*/
        padding: 12px 20px;/*no*/

        img{
          width: 40px;/*no*/
          height: 40px;/*no*/
        }
        span{
          font-size: 20px; /*no*/
          margin-top: 14px;/*no*/
        }
        .lineDiv{
          width: 90px;/*no*/
          height: 3px; /*no*/
          margin: 12px auto;/*no*/
          border-radius: 2px;/*no*/
        }
        
        p{
          font-size: 15px;/*no*/
          margin-top: 20px;/*no*/
        }
        .knowBtn{
          width: 100px; /*no*/
          height: 30px; /*no*/
          line-height: 20px;/*no*/
          margin: 20px auto;/*no*/
          font-size: 10px; /*no*/
          border-width: 1px;/*no*/
          border-radius: 5px;  /*no*/        
        }
      }
  }

  .fintech-box{

    .fintech-detail{
      -webkit-line-clamp: 1;
      font-size: 10px; /*no*/
      line-height: 15px;/*no*/
    }
    .fintech-desc{
      font-size: 10px; /*no*/
      line-height: 15px;/*no*/
    }
    .modao-box{
      // width: 400px;/*no*/
      // height: 135px;/*no*/
    }

  }
}


</style>


// WEBPACK FOOTER //
// src/pages/Solution.vue